import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AwsAuthService } from '@nx/auth';

@Injectable({
  providedIn: 'root'
})
export class UserSignedInGuard  {
  constructor(private AwsAuthService: AwsAuthService, private router: Router) { };

  canActivate(): Promise<boolean> {
    return this.AwsAuthService.isUserLoggedIn().then(user => {
      if (!user) {
        return true;
      } else {
        this.router.navigate(['/'])
        return false;
      }
    })
  }
}
